import { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { SetCourseModuleSortOrder } from "../../actions/superUserMutations";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { formatServiceError } from "../../Utilities/serviceErrorHelper";

export default function SetCourseModuleSortOrderModal({
  isOpen,
  toggle,
  modules,
  courseId,
  reloadModules,
}) {
  const intl = useIntl();
  const [sortedModules, setSortedModules] = useState([]);

  useEffect(() => {
    setSortedModules(
      modules.map((mod) => ({
        sortOrder: mod.sortOrder,
        id: mod.moduleId,
        name: mod.module.name,
      }))
    );
  }, [modules]);

  const mutateSetModuleOrder = useMutation({ mutationFn: SetCourseModuleSortOrder });

  const handleSaveOrder = () => {
    let postObject = {
      courseId: courseId,
      orderedModuleIds: sortedModules.map((mod) => mod.id),
    };
    mutateSetModuleOrder.mutate(postObject, {
      onSuccess: () => {
        toast.success("Ordning sparad");
        reloadModules();
      },
      onError: (err) => {
        toast.warn(formatServiceError(intl, err?.response?.data));
      },
    });
    toggle();
  };

  const handleDrop = (droppedItem) => {
    if (!droppedItem.destination) return;
    var updatedList = [...sortedModules];

    const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);

    updatedList.splice(droppedItem.destination.index, 0, reorderedItem);

    setSortedModules(updatedList);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md">
      <ModalHeader>
        <p>
          <FormattedMessage id="ChangeOrderForModulesInCourse" />
        </p>
        <small className="text-muted">
          <FormattedMessage id="DragAndDropToChangeOrder" />
        </small>
      </ModalHeader>
      <ModalBody className="mx-auto">
        <DragDropContext onDragEnd={handleDrop}>
          <Droppable droppableId="list-container">
            {(provided) => (
              <div
                className="list-container"
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {sortedModules.map((item, index) => (
                  <Draggable
                    key={item.id}
                    draggableId={"draggableItem" + item.id}
                    index={index}
                  >
                    {(provided) => (
                      <div
                        className="draggable--item"
                        ref={provided.innerRef}
                        {...provided.dragHandleProps}
                        {...provided.draggableProps}
                      >
                        <span
                          style={{
                            display: "inline-block",
                            maxWidth: "350px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {item.name}
                        </span>
                        <DragIndicatorIcon className="drag--indicator" />
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </ModalBody>
      <ModalFooter>
        <div className="d-flex">
          <Button
            onClick={toggle}
            className="pull-right mx-1"
            color="secondary"
            outline
          >
            <FormattedMessage id="Cancel" />
          </Button>

          <Button
            onClick={() => handleSaveOrder()}
            className="pull-right mx-1"
            color="primary"
            outline
          >
            <FormattedMessage id="Save" />
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
}
